import React from 'react';
import { View, Text } from 'react-native';
import { Button, Hr, InfoBox } from 'LocalGluons';
import { func, string } from 'prop-types';
import { t } from 'Locale';
import defaultStyles from '../PageStyles.jss';

/**
 * @typedef {{ onOk(): void, title: string }} Props
 */

/**
 * @param {Props} props
 */
const CodeSent = ({ title, onOk }) => (
    <View style={defaultStyles.container}>
        <Text style={defaultStyles.title}>{title}</Text>
        <Hr />
        <InfoBox
            style={[defaultStyles.infoBox, { marginBottom: 40 }]}
            message={t('COMMON.SENT_SUCCESSFULLY')}
            isPositive
        />
        <View style={defaultStyles.buttonWidth}>
            <Button style={defaultStyles.button} title={t('COMMON.OK')} onPress={() => onOk()} />
        </View>
    </View>
);

CodeSent.propTypes = {
    onOk: func.isRequired,
    title: string.isRequired
};

export default CodeSent;
